import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from './progress-bar.component';
import { IconModule } from '../icon/icon.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ProgressBarComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconModule
  ],
  exports: [
    ProgressBarComponent
  ]
})
export class ProgressBarModule { }
